enum Level {
    Emergency = 'emergency',
    Alert     = 'alert',
    Critical  = 'critical',
    Error     = 'error',
    Warning   = 'warning',
    Notice    = 'notice',
    Info     = 'info',
    Debug     = 'debug',
}

export default Level
